
import {
  getAntSmsAccount,
  addAntSmsAccount,
  deleteAntSmsAccount,
  editWallet,
  getAntSmsLog,
} from '@/api/product/smsAccount'
import { delObjEmptyKey } from '@/utils'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'
import pagination from '@/components/Pagination/index.vue'
import { AppModule } from '@/store/modules/app'
import addAntManage from './components/addAntManage.vue'
import viewLog from './components/log.vue'
import editAccount from './components/edit.vue'
@Component({
  name: 'log',
  components: {
    pagination,
    addAntManage,
    viewLog,
    editAccount,
  },
})
export default class extends Vue {
  private listLoading: boolean = true
  private listQuery = {
    page: 1,
    limit: 20,
  }
  private queryForm: any = {
    account_name: '',
    account_type: '',
    status: '',
  }
  private list: any[] = []
  private total = 0
  // private date: any[] = getCurrentDate()
  // private pickerOptions = pickerOptions

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      await getAntSmsAccount(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 创建时间监听
  // @Watch('date', { immediate: true })
  // private pickerChange () {
  //   if (this.date) {
  //     this.queryForm.start_time = dateToSeconds(this.date[0])
  //     this.queryForm.end_time = dateToSeconds(this.date[1])
  //   } else {
  //     this.queryForm.start_time = null
  //     this.queryForm.end_time = null
  //   }
  // }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      account_name: '',
      account_type: '',
      status: '',
      // start_time: null,
      // end_time: null
    }
    // this.date = getCurrentDate()
    this.currentPage = 1
    // this.getLog(true)
    this.hadleGetFilesListApi()
  }

  private dialogVisible: boolean = false
  private openDialogVisible(action: string) {
    this.dialogVisible = true
  }

  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
    // if (this.ancestor !== '') {
    //   this.hadleGetFilesListApi()
    // }
  }

  // 删除商户
  private del(id: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: (action) => {
        if (action === 'confirm') {
          this.delMerchant(id)
        }
      },
    })
  }

  private async delMerchant(data: any) {
    await deleteAntSmsAccount(data).then(() => {
      this.$message.success('Delete Successfully')
      this.hadleGetFilesListApi()
    })
  }

  private versionDrawer: boolean = false
  private activeName: string = '1'
  private openLog(row: any) {
    this.versionDrawer = true
  }

  private editDrawer: boolean = false
  private editRow: any = {}
  private openOnePay(row: any) {
    this.editDrawer = true
    this.editRow = row
  }
  private getEditClose() {
    this.editDrawer = false
    this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    // this.getLog(true)
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.smsAccount`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
